import { Injectable, computed, inject, signal } from '@angular/core';
import { BoxesEntry, FileUpload, RegressionEntry } from '@models';
import { SceneStore } from '@stores';
import JSZip from 'jszip';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class MlTrackingService {
  sceneStore = inject(SceneStore);

  jsonString: string;
  trackingDataUpload: FileUpload;

  private trackedData = signal<(BoxesEntry | RegressionEntry)[]>([]);
  private startTime: number;

  initalizeTracking(): void {
    this.startTime = Date.now();
  }

  track(entry: BoxesEntry | RegressionEntry): void {
    this.trackedData.update((trackedData) => [
      ...trackedData,
      { ...entry, time: Date.now() - this.startTime },
    ]);
  }

  isTrackingAvailable = computed(() => this.trackedData().length > 0);

  prepareTrackingFile(): void {
    const writeData = this.trackedData().map((entry) => ({
      ...entry,
      detections: [...entry.detections],
    }));
    this.jsonString = JSON.stringify(
      {
        sceneName: this.sceneStore.selectedScene,
        tracking: writeData,
      },
      null,
      2,
    );

    const zip = new JSZip();
    zip.file('tracking.json', this.jsonString);
    zip.generateAsync({ type: 'blob' }).then((blob) => {
      this.trackingDataUpload = {
        id: uuidv4(),
        mimeType: 'application/x-zip',
        blob,
      };
    });
  }

  saveToFile(): void {
    this.prepareTrackingFile();
    const blob = new Blob([this.jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'tracking.json';
    anchor.click();
    URL.revokeObjectURL(url);
  }
}
